import { ForgotPasswordForm } from "../components/ForgotPasswordForm";
import { Layout } from "../components/Layout";

export const ForgotPassword = () => {
  return (
    <Layout title="Forgot Password">
      <ForgotPasswordForm />
    </Layout>
  );
};
